// @ts-nocheck

import React, { useMemo } from 'react';

import { useShallowEqualSelector } from '../../hooks';
import useMergeProps from '../../hooks/useMergeProps';
import { selectRuntimeIsWTVEnabled } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserPrefsShowWTV } from '../../selectors/user/userPrimary.selector';
import useWinabetLibContext from '../../winabet-lib/hooks/useWinabetLibContext';

import PiPProvider from './PiPProvider';

type PiPProviderContainerProps = {
  children: Node;
};

const PiPProviderContainer = ({ children }: PiPProviderContainerProps) => {
  const selectedProps = useShallowEqualSelector((state) => ({
    showWTV: selectUserPrefsShowWTV(state),
    isWTVEnabled: selectRuntimeIsWTVEnabled(state),
  }));

  const winabetLibContext = useWinabetLibContext();
  const { onMatchStreamExport } = winabetLibContext?.sharedActions ?? {};

  const otherProps = useMemo(() => ({ onMatchStreamExport }), [onMatchStreamExport]);

  const enhancedProps = useMergeProps({ selectedProps, otherProps });

  return <PiPProvider {...enhancedProps}>{children}</PiPProvider>;
};

export default PiPProviderContainer;
